/* eslint-disable */
export let THEME_COLOR = '#445FBB';

// ====== 后端环境切换：只改这一个 BACKEND_HOST 即可 ======
// 线上：https://lvlin.baidu.com
const BACKEND_HOST = 'https://lvlin.baidu.com';
// const BACKEND_HOST = 'http://m1-ps-beehive-agent171038.m1.baidu.com:8203';
// =====================================================

export let API_HOST = BACKEND_HOST;
// ab实验-request-header域名
export let EXP_HOST_HEADER = '';

// 不同的接口对应不同的服务（如需分服务部署，可单独覆盖某个 key）
export const HOSTS = {
  'law': BACKEND_HOST,
  'swan': BACKEND_HOST,
  'usercenter': BACKEND_HOST,
  'falv': BACKEND_HOST,
  'lawqb': BACKEND_HOST,
  'bp': BACKEND_HOST,
  'income': BACKEND_HOST
};
// 拼接页面首屏请求链接
export let reqPathTo = (page, param = {}, host, prefix = 'law/sync') => {
  let url = prefix ? prefix + '/' + page : page;
  let urlHost = handleHost(url);
  if (!param.vn) {
    param.vn = 'law';
  }
  let gData = getApp().globalData;
  // prefetch 阶段获取不到 globalData 中的数据
  if (gData) {
    if (param.sf_ref) {
      gData.ref = gData.ref ? gData.ref : param.sf_ref;
    } else {
      param.sf_ref = gData.ref;
    }
  }

  // 添加页面来源clientType
  param.clientType = "h5";
  let paramArr = [];
  Object.keys(param).forEach(item => {
    if (item === 'postUrl') {
      paramArr.push(`${item}=${encodeURIComponent(param[item])}`);
    } else {
      paramArr.push(`${item}=${param[item]}`);
    }
  });
  return (host || `${urlHost}/${prefix}/`) + page + '?' + paramArr.join('&');
};
// 拼接页面首屏请求链接
export let reqPathToSearch = (page, param = {}) => {
  let url = '/law/search/' + page;
  let urlHost = handleHost(url);
  if (!param.vn) {
    param.vn = 'law';
  }
  let gData = getApp().globalData;
  if (param.sf_ref) {
    gData.ref = gData.ref ? gData.ref : param.sf_ref;
  } else {
    param.sf_ref = gData.ref;
  }
  let paramArr = [];
  Object.keys(param).forEach(item => {
    if (item === 'postUrl') {
      paramArr.push(`${item}=${encodeURIComponent(param[item])}`);
    } else {
      paramArr.push(`${item}=${param[item]}`);
    }
  });
  return urlHost + url + '?' + paramArr.join('&');
};

/**
 * 针对小程序处理不同后端服务的host
 * @param {String} url 请求的接口
 */

export const handleHost = url => {
  // 解决跨域问题

  return '';
};
/* eslint-enable */